module.exports = __webpack_public_path__ + "img/5yina_banner.e9c25671.jpg";